import { CurtainsClosedIcon } from './CurtainsClosedIcon';

/**
 * author: Teodor Sandu
 * id EB23B6A0-2021-405D-83F2-D69D9A5CF1CD
 * name curtains-closed
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/curtains-closed.svg
 * tags
 * - Home Automation 
 */
export const DrapesClosedIcon = CurtainsClosedIcon;
export default DrapesClosedIcon